import react from '../assets/svg/achievements/1.jpg'
import java from '../assets/svg/achievements/2.jpg'
import react2 from '../assets/svg/achievements/4.jpg'
export const achievementData = {
    bio : "The illiterate of the 21st century will not be those who cannot read and write, but those who cannot learn, unlearn, and relearn. - Alvin Toffler",
    achievements : [

        {
            id : 1,
            title : 'Online training on JAVA',
            details : 'Cipher Schools',
            date : 'Feb 07, 2022',
            link : 'https://drive.google.com/file/d/1gujfKwptp2rla_BGAlJzxTFNBBM7zEoV/view?usp=sharing',
            image : java
        },
        {
            id : 2,
            title : 'Front-End Web Development with React',
            details : 'The Hong Kong University of Science and Technology',
            date : 'Mar 21, 2022',
            link: 'https://coursera.org/share/63f1f9b3c72c90e24e82d8a12695b747',
            image : react
        },
       
       
        {
            id : 3,
            title : 'React and Redux',
            details : 'Cipher Schools',
            date : 'Jul 25, 2022',
            link : 'https://drive.google.com/file/d/1ip6bsx78hMcKwZGWWBbuZo79TlqiJhIw/view?usp=sharing',
            image:react2
        }

    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.
